import React from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { CheckIcon } from 'lucide-react';
interface ToastProps {
  message: string | null;
}
export function Toast({
  message
}: ToastProps) {
  return <div className="pointer-events-none fixed inset-x-0 bottom-24 z-[60] flex justify-center px-4" role="status" aria-live="polite" data-id="element-176" data-mp="a8lqhyowr0y0">
      <AnimatePresence data-id="element-177" data-mp="f4kgfqpvwr0j">
        {message && <motion.div initial={{
        opacity: 0,
        y: 12,
        scale: 0.96
      }} animate={{
        opacity: 1,
        y: 0,
        scale: 1
      }} exit={{
        opacity: 0,
        y: 8,
        scale: 0.98
      }} transition={{
        duration: 0.2,
        ease: [0.23, 1, 0.32, 1]
      }} className="flex items-center gap-2 rounded-full bg-ink px-4 py-2.5 text-[13px] text-cream shadow-card" data-id="element-178" data-mp="12xj77xdh0pon">
            <CheckIcon className="h-4 w-4 text-mocha-soft" strokeWidth={2} data-id="element-179" data-mp="3do9ktcvqni4d" />
            {message}
          </motion.div>}
      </AnimatePresence>
    </div>;
}